import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên danh mục:")
], -1)
const _hoisted_2 = { class: "col-3 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mô tả:")
], -1)
const _hoisted_4 = { class: "col-4 d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Danh mục cha:")
], -1)
const _hoisted_6 = { class: "col-4 d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, null, -1)
const _hoisted_8 = { class: "col-2 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa') + " danh mục toa xe ", 1)
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "form",
        model: _ctx.danhMucToaXeForm,
        rules: _ctx.rules,
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DivRow, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  prop: "ten_danh_muc",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.danhMucToaXeForm.ten_danh_muc,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.danhMucToaXeForm.ten_danh_muc) = $event)),
                      placeholder: "tên danh mục toa xe",
                      name: "ten_danh_muc",
                      onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  prop: "mo_ta",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.danhMucToaXeForm.mo_ta,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.danhMucToaXeForm.mo_ta) = $event)),
                      type: "textarea",
                      placeholder: "Mô tả danh mục vật tư",
                      name: "mo_ta",
                      onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_form_item, {
                  prop: "id_cha",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.danhMucToaXeForm.id_cha,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.danhMucToaXeForm.id_cha) = $event)),
                      placeholder: "Danh mục toa xe cha",
                      name: "id_cha"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: 0,
                          label: "Không chọn"
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.danhMucToaXeChaItems, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.ten_danh_muc,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_DivRow, { class: "mt-2" }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.SAVE,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  onClick: _ctx.submit
                }, null, 8, ["button-type", "color-type", "onClick"]),
                _createVNode(_component_ButtonCustom, {
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "button-type": _ctx.ButtonsType.TRASH,
                  onClick: _ctx.clear
                }, null, 8, ["color-type", "button-type", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"])
    ]),
    _: 1
  }))
}